import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class Benefits extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    // gsap.set(this.el, { autoAlpha: 0 })
  }

  animate() {
    const leftText = qsa(".title .char-1", this.el)
    const items = qsa(".item", this.el)
    const borders = qsa(".border", this.el)

    const lines = qsa(".line-0", this.el)
    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    gsap.from(leftText, {
      y: 100,
      stagger: 0.03,
      duration: 1.2,
      scrollTrigger: {
        trigger: leftText,
        start: "top bottom",
      },
    })

    items.forEach((item, i) => {
      const chars = qsa(".char-1", item)

      gsap.from(chars, {
        y: "100%",
        duration: 1.2,
        stagger: 0.04,
        delay: i * 0.01,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
        },
      })
    })
    gsap.from(borders, {
      scaleX: 0,
      stagger: 0.07,
      duration: 1.2,
      scrollTrigger: {
        trigger: borders,
        start: "top bottom",
      },
    })

    // gsap.set(this.el, { autoAlpha: 1 })
  }
}
